import React from 'react';
import { Link } from "react-router-dom";
import {createUserInvite} from '../services/UserService'

class SendUserInvite extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           jwtToken: props.jwtToken,
           inviteAdmin: false
        };
        this.handleCreateInputChange = this.handleCreateInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleCreateInputChange = (e) => {
        this.setState({ inviteAdmin: e.target.checked });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        createUserInvite(this.state.jwtToken, this.state.inviteAdmin)
        .then(response =>
            {
                var invite = window.location.hostname + ":" + window.location.port + "/user/invite/"  + response;
                document.getElementById("inviteUrl").value = invite;
            }
        );
    };

    render() {
    return (
    <>
        <div className="row" style={{marginLeft: "4%", marginRight: "4%"}}>
            <h1>
                <Link to="/">
                    <span title="Return to experiment listing">All experiments/</span>
                </Link>
                Send user invite
            </h1>
            <form style={{width: "550px", paddingTop:"10px"}}>
                <div className="form-group">
                    <label>Generated invite</label>
                    <input className="form-control" type="text" id="inviteUrl" readOnly/>
                </div>
                <div className="form-group" style={{display: "flex", flexWrap: "wrap"}}>
                    <label style={{marginTop: "3px", marginRight: "20px"}}>Is admin</label>
                    <input className="form-control" type="checkbox" id="inviteAdmin" placeholder="Grant admin role"
                        style={{width: "20px", height: "20px"}}
                        onChange={(e) => this.handleCreateInputChange(e)}/>
                </div>
                <button type="submit" className="btn btn-primary" onClick={this.handleSubmit} >
                    Create invite
                </button>
            </form>
        </div>
    </>
    );
    }
}

export default SendUserInvite;
